var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefCaseSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / M / Brief Case",
    clipPath: "url(#clip0_19683_26015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4631 22.4553C1.8231 22.8184 2.2431 23 2.7231 23H23.1231C23.6031 23 24.0231 22.8184 24.3831 22.4553C24.7431 22.0921 24.9231 21.6684 24.9231 21.1842V19H0.923096V21.1842C0.923096 21.6684 1.1031 22.0921 1.4631 22.4553ZM0.923096 17H24.9231V6.65789C24.9231 6.17368 24.7431 5.75 24.3831 5.38684C24.0231 5.02368 23.6031 4.84211 23.1231 4.84211H17.7231V1.81579C17.7231 1.33158 17.5431 0.907895 17.1831 0.544737C16.8231 0.181579 16.4031 0 15.9231 0H9.9231C9.4431 0 9.0231 0.181579 8.6631 0.544737C8.3031 0.907895 8.1231 1.33158 8.1231 1.81579V4.84211H2.7231C2.2431 4.84211 1.8231 5.02368 1.4631 5.38684C1.1031 5.75 0.923096 6.17368 0.923096 6.65789V17ZM15.9231 4.84211H9.9231V1.81579H15.9231V4.84211Z",
    fill: "#1A1E23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19683_26015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.923096)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefCaseSolid);
export default __webpack_public_path__ + "static/media/brief-case-solid.08d5c10a2c32e9690eff0232a0e06219.svg";
export { ForwardRef as ReactComponent };